import { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import api from '../../../../services/api';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Loading from '../../../../load/loading';
import HeaderSession from '../../../../utils/headerSession';
import { Card, Paper, Typography } from '@mui/material';
import RegisterAccess from '../../../../utils/registerAccess';
import { makeStyles } from '@material-ui/core';
import ListaVazia from '../../../../utils/listaVazia';
import Date from '../../../../utils/date';
import FerramentaNavegacaoExportacao from '../../../../utils/paginacao';
import TempoPassado from '../../../../utils/tempoPassado';


const useStyles = makeStyles((theme) => ({
  hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' },
}))

const ListaSolicitacoesDesalfandegamento = () => {
  const classes = useStyles();
  const { status } = useParams()
  const [solicitacoes, setSolicitacoes] = useState('');
  // const [status, setStatus] = useState('Análise');
  const [configLista, setConfigLista] = useState('');
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));

  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/declaracao-desalfandegamentos?status=${status}&page=${page}`)
      .then(response => {
        // console.log(response)
        setSolicitacoes(response.data.declaracaoDesalfandegamentos)
        setConfigLista(response.data)
      }).catch(err => {
        // console.log(err)
      })
  }, [status, page])


  // const filtraReclamacoes = (valor) => {
  //   setSolicitacoes(filter.filter((espedienteGeral) => (espedienteGeral?.nome?.toLowerCase().includes(valor.toLowerCase()))))
  // }

  return (

    <>
      <RegisterAccess page={'lista de solicitações de desalfandegamento'} />
      <HeaderSession title={'SOLICITAÇÕES DE DESALFANDEGAMENTO'} />

      {solicitacoes ? solicitacoes.length > 0 ?

        <Card variant="outlined" sx={{ width: '100%', overflow: 'hidden' }} >
          <TableContainer sx={{ border: "1px black" }} component={Paper}>
            <Table sx={{ border: "1px", borderColor: "black" }}>
              <TableHead sx={{ backgroundColor: "#dcdede" }}>
                <TableRow>
                  <TableCell align="center" ><Typography noWrap> <strong> Importador </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Nº de Declaração </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Ponto de Entrada </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Destino </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Estado </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Data </strong></Typography></TableCell>
                  <TableCell ><Typography noWrap> <strong>Ultima intervenção</strong></Typography></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {solicitacoes.map((solicitacao) => (
                  <TableRow key={solicitacao._id} className={classes.hover} onClick={() => { navigate(`/admin/dmts/gest/solicitacao-de-desalfandegamento/${solicitacao?.solicitacaoImportacaoId}`) }}>
                    <TableCell ><Typography noWrap> {solicitacao.importador?.nome}</Typography></TableCell>
                    <TableCell  ><Typography > {solicitacao.numeroDeclaracao}</Typography></TableCell>
                    <TableCell  ><Typography > {solicitacao.pontoEntrada}</Typography></TableCell>
                    <TableCell  ><Typography noWrap> {solicitacao.destino}</Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> {solicitacao?.status} </Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> <Date date={solicitacao?.createdAt} /> </Typography></TableCell>
                    <TableCell ><TempoPassado date={solicitacao.updatedAt} /> </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <FerramentaNavegacaoExportacao
            configLista={configLista}
            lista={solicitacoes}
            page={page}
            setPage={setPage}
          />
        </Card>
        :
        <ListaVazia />
        :
        <Loading text={'A carregar solicitações'} />
      }
    </>
  )
}

export default ListaSolicitacoesDesalfandegamento 
